// removed by extract-text-webpack-plugin
module.exports = {"cookie-notification":"cookie-notification","visible":"visible","button-acknowledge-policy":"button-acknowledge-policy"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/cookie-notification/cookie-notification.style.sass
// module id = gZSy
// module chunks = 0